import React, { Fragment } from 'react'
import styled from 'styled-components'

import AnalyticsObject from '@/docs-partials/api/schema/analytics-object.mdx'
import CategoryObject from '@/docs-partials/api/schema/category-object.mdx'
import ChannelObject from '@/docs-partials/api/schema/channel-object.mdx'
import ChannelTagObject from '@/docs-partials/api/schema/channel-tag-object.mdx'
import GifObject from '@/docs-partials/api/schema/gif-object.mdx'
import ImageObject from '@/docs-partials/api/schema/image-object.mdx'
import MetaObject from '@/docs-partials/api/schema/meta-object.mdx'
import PaginationObject from '@/docs-partials/api/schema/pagination-object.mdx'
import RandomIdObject from '@/docs-partials/api/schema/randomId-object.mdx'
import SectionHeader from '@/docs-partials/api/schema/section-header.mdx'
import SubCategoryObject from '@/docs-partials/api/schema/sub-category-object.mdx'
import TermObject from '@/docs-partials/api/schema/term-object.mdx'
import UserObject from '@/docs-partials/api/schema/user-object.mdx'
import { Anchor } from '@/components/ui/anchor'
import { ApiDocsSectionWrapper } from '@/components/common/api-docs-section-wrapper'
import { Divider } from '@/components/ui/divider'

const ObjectWrapper = styled(ApiDocsSectionWrapper)`
  > table td:first-child {
    font-weight: normal;
  }
`

const ImageObjectWrapper = styled.div`
  && table {
    empty-cells: hide;
  }

  && table td {
    vertical-align: top;
  }
`

type SchemaObjectProps = {
  anchorId: string
  dividerLine?: boolean
}

const SchemaObject: React.FC<SchemaObjectProps> = ({ children, anchorId, dividerLine = true }) => {
  return (
    <ObjectWrapper>
      {dividerLine ? <Divider /> : ''}
      <Anchor pathname="/docs/api/schema" id={anchorId} />
      {children}
    </ObjectWrapper>
  )
}

const EndpointsPage = () => {
  return (
    <Fragment>
      <div>
        <SectionHeader />
        <SchemaObject anchorId="gif-object" dividerLine={false}>
          <GifObject />
        </SchemaObject>
        <SchemaObject anchorId="image-object">
          <ImageObjectWrapper>
            <ImageObject />
          </ImageObjectWrapper>
        </SchemaObject>
        <SchemaObject anchorId="meta-object">
          <MetaObject />
        </SchemaObject>
        <SchemaObject anchorId="pagination-object">
          <PaginationObject />
        </SchemaObject>
        <SchemaObject anchorId="user-object">
          <UserObject />
        </SchemaObject>
        <SchemaObject anchorId="random-id-object">
          <RandomIdObject />
        </SchemaObject>
        <SchemaObject anchorId="analytics-object">
          <AnalyticsObject />
        </SchemaObject>
        <SchemaObject anchorId="category-object">
          <CategoryObject />
        </SchemaObject>
        <SchemaObject anchorId="sub-category-object">
          <SubCategoryObject />
        </SchemaObject>
        <SchemaObject anchorId="term-object">
          <TermObject />
        </SchemaObject>
        <SchemaObject anchorId="channel-object">
          <ChannelObject />
        </SchemaObject>
        <SchemaObject anchorId="channel-tag-object">
          <ChannelTagObject />
        </SchemaObject>
      </div>
    </Fragment>
  )
}

export default EndpointsPage
